module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-question",
    class: _vm.qd_index % 2 === 0 ? 'even' : 'odd'
  }, [_c('div', {
    staticClass: "card-content card-content-question"
  }, [(_vm.review) ? _c('div', {
    staticClass: "opacity"
  }) : _vm._e(), _c('div', {
    staticClass: "sequence"
  }, [_vm._v("câu hỏi "), (_vm.type_question === 2) ? _c('span', {
    staticClass: "qindex"
  }, [_vm._v(_vm._s(_vm.qd_index))]) : _vm._e(), (_vm.type_question === 2) ? _c('i', {
    staticClass: "material-icons ic-delete",
    on: {
      "click": function($event) {
        return _vm.deleteQuestionDetail(_vm.qd_index)
      }
    }
  }, [_vm._v("delete")]) : _vm._e()]), _c('div', {
    staticClass: "row group-options"
  }, [_c('div', {
    staticClass: "col-md-10 shuffle"
  }, [_c('div', {
    staticClass: "col-md-5 title"
  }, [_vm._v("Dạng đáp án *")]), _c('div', {
    staticClass: "col-md-3 option"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": 'typeAnswer1_' + _vm.qd_index,
      "name": 'fmType' + _vm.qd_index
    },
    domProps: {
      "checked": _vm.dataQD.type === 1
    },
    on: {
      "click": function($event) {
        return _vm.onChangeType(1)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'typeAnswer1_' + _vm.qd_index
    }
  }, [_vm._v("Chọn đáp án đúng")])]), _c('div', {
    staticClass: "col-md-3 option"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": 'typeAnswer2_' + _vm.qd_index,
      "name": 'fmType' + _vm.qd_index
    },
    domProps: {
      "checked": _vm.dataQD.type === 2
    },
    on: {
      "click": function($event) {
        return _vm.onChangeType(2)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'typeAnswer2_' + _vm.qd_index
    }
  }, [_vm._v("Nhập câu trả lời")])])]), (_vm.dataQD.type === 1) ? _c('div', {
    staticClass: "col-md-10 shuffle"
  }, [_c('div', {
    staticClass: "col-md-5 title"
  }, [_vm._v("Trộn đáp án trong các lần hiển thị khác nhau *")]), _c('div', {
    staticClass: "col-md-3 option"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": 'shuffle1_' + _vm.qd_index,
      "name": 'shuffle' + _vm.qd_index
    },
    domProps: {
      "checked": _vm.dataQD.shuffle
    },
    on: {
      "click": function($event) {
        return _vm.onChangeShuffle(true)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'shuffle1_' + _vm.qd_index
    }
  }, [_vm._v("Có")])]), _c('div', {
    staticClass: "col-md-3 option"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": 'shuffle2_' + _vm.qd_index,
      "name": 'shuffle' + _vm.qd_index
    },
    domProps: {
      "checked": !_vm.dataQD.shuffle
    },
    on: {
      "click": function($event) {
        return _vm.onChangeShuffle(false)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'shuffle2_' + _vm.qd_index
    }
  }, [_vm._v("Không")])])]) : _vm._e(), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "row row-content"
  }, [(_vm.type_question === 2) ? _c('div', {
    staticClass: "col-md-6 content-question-detail"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nội dung câu hỏi *")]), _c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.config
    },
    on: {
      "input": function($event) {
        return _vm.changeContentQD($event)
      }
    },
    model: {
      value: (_vm.dataQD.content),
      callback: function($$v) {
        _vm.$set(_vm.dataQD, "content", $$v)
      },
      expression: "dataQD.content"
    }
  })], 1)]) : _vm._e(), _c('div', {
    class: _vm.type_question === 2 ? 'col-md-6 content-explain' : 'col-md-12 content-explain',
    style: (_vm.type_question === 1 ? 'padding-left: 15px; padding-right: 15px;' : '')
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Giải thích đáp án *")]), _c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.config
    },
    on: {
      "input": function($event) {
        return _vm.changeExplain($event)
      }
    },
    model: {
      value: (_vm.dataQD.explain),
      callback: function($$v) {
        _vm.$set(_vm.dataQD, "explain", $$v)
      },
      expression: "dataQD.explain"
    }
  })], 1)]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "row row-point"
  }, [_c('div', {
    staticClass: "col-md-6 correct-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Điểm cộng khi trả lời đúng *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQD.point),
      expression: "dataQD.point"
    }],
    staticClass: "form-control",
    attrs: {
      "id": 'plus' + _vm.qd_index,
      "type": "number",
      "required": "required",
      "value": "0",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dataQD.point)
    },
    on: {
      "change": function($event) {
        return _vm.changePoint(_vm.dataQD.point, true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataQD, "point", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 wrong-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Điểm trừ khi trả lời sai *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQD.subpoint),
      expression: "dataQD.subpoint"
    }],
    staticClass: "form-control",
    attrs: {
      "id": 'minus' + _vm.qd_index,
      "type": "number",
      "required": "required",
      "value": "0",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dataQD.subpoint)
    },
    on: {
      "change": function($event) {
        return _vm.changePoint(_vm.dataQD.subpoint, false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataQD, "subpoint", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-12 theory-related"
  }, [_c('div', {
    staticClass: "row-theory"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-theory"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Lý thuyết liên quan *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": 'lesson_id' + _vm.qd_index,
      "name": "lesson_id",
      "required": "required"
    },
    on: {
      "change": _vm.onChangeLessonRelated
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Chọn lý thuyết")]), _vm._l((_vm.dataQD.lessonRemaining), function(o) {
    return _c('option', {
      attrs: {
        "data-content": o.content
      },
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])])]), _c('div', {
    staticClass: "div-lines"
  }, _vm._l((_vm.dataQD.lessonRelated), function(o, iLesson) {
    return (o) ? _c('div', {
      staticClass: "col-md-12 theory-lines"
    }, [_c('div', {
      staticClass: "box-item-line"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(o.name))])]), _c('div', {
      staticClass: "ic_handle"
    }, [_c('i', {
      staticClass: "material-icons",
      on: {
        "click": function($event) {
          return _vm.editTheory(o)
        }
      }
    }, [_vm._v("edit")]), _c('i', {
      staticClass: "material-icons",
      on: {
        "click": function($event) {
          return _vm.deleteTheory(iLesson)
        }
      }
    }, [_vm._v("delete")])])]), _c('div', {
      staticClass: "content",
      domProps: {
        "textContent": _vm._s(_vm.stripedHtml(o.content))
      }
    })])]) : _vm._e()
  }), 0), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "row row-answer"
  }, [(_vm.dataQD.answers.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Đáp án *")])]) : _vm._e(), _vm._l((_vm.dataQD.answers), function(o, iAnswer) {
    return _c('div', {
      staticClass: "col-md-12 col-md-answer"
    }, [_c('answer', {
      key: _vm.force,
      attrs: {
        "qd_index": _vm.qd_index,
        "value": String.fromCharCode(_vm.value + iAnswer),
        "iAnswer": iAnswer,
        "id": o.count,
        "isChecked": o.checked,
        "type": _vm.dataQD.type,
        "content": o.content
      },
      on: {
        "onCheckedAnswer": _vm.updateCheckbox,
        "onDeleteAnswer": _vm.deleteAnswer
      }
    }), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }), (_vm.dataQD.type === 1) ? _c('div', {
    staticClass: "col-md-12 col-add-answer"
  }, [_c('span', {
    staticClass: "add-answer",
    on: {
      "click": _vm.addAnswer
    }
  }, [_vm._v("+ Thêm đáp án")])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c3f1765","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question/QuestionDetail/index.vue
// module id = 1481
// module chunks = 0